<template>
	<div class="content_wrap">
		<div class="warp clearfix bg">
			<div class="left_meun fl" id="leftMenuStatue">
				<ul>
					<li v-for='(item,index) in lists' @click="change(index,item)" :class='{cur:index==number}'>
						<a :href="item.url">
							{{item.name}}<span class="left_meun_sup" v-text="msgCount" v-if="item.isShow"></span>
						</a>
					</li>
				</ul>
			</div>
			<router-view class="fl"></router-view>
		</div>
	</div>

</template>

<script type="text/javascript">
	import { mapState } from 'vuex'
	export default {
		name: "developCenter",
		data() {
			return {
				number: sessionStorage.getItem('deveIndex') || 0,
				lists: [{
						name: "开发者信息",
						url: '#/developCenter/developNews',
						isShow: false
					},
					{
						name: "联系人信息",
						url: '#/developCenter/userNews',
						isShow: false
					},
					{
						name: "站内通知",
						url: '#/developCenter/stationNotice',
						isShow: true
					},

				]
			}
		},
		computed: {
			...mapState([
				'msgCount'
			])
		},
		methods: {
			change(index, item) {
				this.number = index;
				sessionStorage.setItem('deveIndex', this.number)
			},
		},
		mounted() { //相当于document.ready后执行的方法 ，DOM元素全部都加载完成之后执行的方法
			const that = this;
			let devParams = {
				"devId": sessionStorage.getItem('devId') || 1
			};
			if(!location.href.includes('open.yinshuitong.com')) {
				this.lists.push({
					name: "发票核验",
					url: '#/developCenter/invoiceCheck',
					isShow: false,
        },
        {
					name: "埋数工具",
					url: '#/developCenter/mockTool',
					isShow: false,
        }
				)
			}
			let index = this.lists.findIndex(item => location.href.includes(item.url))
			this.change(index)
			this.http.post('/ystOpenPlatformBff/getMsgCount', devParams, res => {
				if(res.success) {
					this.$store.dispatch('changeMsgCount', res.data.msgCount)
				} else {
					if(res.message){
						this.$Message.error(res.message);
					}
				}
			})
		}

	}
</script>

<style lang="scss">
	.content_wrap{padding: 30px 0;}
	.bg {
		background: $white;
	}
	.padTop30{padding-top: 30px;}
	.left_meun {
		background: $white;
		width: 219px;
		min-height: 440px;
		margin: 20px 0;
		li {
			line-height: 40px;
			padding-left: 20px;
			border-bottom: 1px solid $border;
			cursor: pointer;
		}
		li a {
			color: $title;
			box-sizing: inherit;
			width: 100%;
			height: 100%;
			display: inline-block;
		}
		li:hover {
			background: $hoverbg;
		}
		li.cur {
			border-right: 3px solid $link;
		}
		li.cur a {
			color: $link;
		}
		/*.left_meun_sup{ display: inline-block; position: relative; width: 16px; height: 16px; line-height: 16px;color: $white; text-align: center; font-size: 12px; border-radius: 50%; top: -6px;}*/
	}
	
	.station_left {
		float: left;
	}
	
	.station_right {
		float: left;
		width: 780px;
		border-left: 1px solid $border;
		margin-top: 20px;
		margin-bottom: 20px;
		min-height: 440px;
	}
	
	.station_right_in {
		padding: 0 20px;
	}
	
	.station_right_h2 {
		height: 40px;
		font-size: 24px;
		font-weight: normal;
		margin-top: 8px;
		margin-bottom: 10px;
		color: $title;
		line-height: 40px;
	}
	
	.station_right_h2_right {
		float: right;
	}
	
	.station_right_h2_right a {
		font-size: 14px;
	}
	
	.station_right_h2_red {
		margin-right: 20px;
		color: $circle
	}
	
	.station_right_h2_sub {}
	
	.msg_item_top {
		background: $base;
		border: 1px solid $baseBord;
		padding: 20px;
		position: relative;
		margin-bottom: 20px;
	}
	
	.msg_item_top span {
		color: $title;
		font-size: 14px;
	}
	
	.contact_card_btn {
		position: absolute;
		top: 20px;
		right: 20px;
	}
	
	.contact_card_btn a {
		color: $gredF;
		font-size: 14px;
	}
	
	.copy_btn {
		color: $link;
		margin-left: 15px;
	}
	
	.msg_item_top ul .dev_list {
		margin-bottom: 20px;
	}
	
	.left_meun_sup {
		display: inline-block;
		position: relative;
		width: 16px;
		height: 16px;
		line-height: 16px;
		color: #fff;
		color: $white;
		background: $circle;
		text-align: center;
		font-size: 12px;
		border-radius: 50%;
		top: -6px;
	}
</style>


// WEBPACK FOOTER //
// src/page/DevelopCenter.vue